module.exports = "data:image/png;base64,77u/bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvYmcuMTBlNmRhYWQucG5nIjs="